exports = module.exports = require("../../../../../../../../tools/web-builder/node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".filter-connected-tiles-tab-h56{width:50%}", "",{"version":3,"sources":["filter-connected-tiles-tab.scss"],"names":[],"mappings":"AACA,gCAEE,SAAA","file":"filter-connected-tiles-tab.scss","sourcesContent":["\r\n.filter-connected-tiles-tab-h56 {\r\n  //width: 486px;\r\n  width: 50%;\r\n}"]}]);

